var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var renderHTML = function (html) {
    if (!html)
        return { __html: "" };
    return { __html: cleanHTML(html) };
};
var cleanHTML = function (html) {
    if (!html)
        return "";
    //fix '~' in links in HTML
    return html.replace(/href="~\//gi, 'href="/');
};
var asyncForEach = function (array, callback) { return __awaiter(_this, void 0, void 0, function () {
    var index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                index = 0;
                _a.label = 1;
            case 1:
                if (!(index < array.length)) return [3 /*break*/, 4];
                return [4 /*yield*/, callback(array[index], index, array)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                index++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
var expandContentList = function (_a) {
    var agility = _a.agility, contentItems = _a.contentItems, languageCode = _a.languageCode, depth = _a.depth;
    return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_b) {
            asyncForEach(contentItems, function (contentItem) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, expandContentItem({ agility: agility, contentItem: contentItem, languageCode: languageCode, depth: depth })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    });
};
var expandContentItem = function (_a) {
    var agility = _a.agility, contentItem = _a.contentItem, languageCode = _a.languageCode, _b = _a.depth, depth = _b === void 0 ? 1 : _b;
    return __awaiter(_this, void 0, void 0, function () {
        var api, fields, _c, _d, _e, _i, fieldName, fieldValue, childItem, sortIDAry, childItems, _f, sortIDAry_1, childItemID, childItem;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!contentItem)
                        return [2 /*return*/, null];
                    api = agility;
                    if (!(depth > 0)) return [3 /*break*/, 9];
                    fields = contentItem.fields;
                    if (!fields)
                        fields = contentItem.customFields;
                    _c = fields;
                    _d = [];
                    for (_e in _c)
                        _d.push(_e);
                    _i = 0;
                    _g.label = 1;
                case 1:
                    if (!(_i < _d.length)) return [3 /*break*/, 9];
                    _e = _d[_i];
                    if (!(_e in _c)) return [3 /*break*/, 8];
                    fieldName = _e;
                    fieldValue = fields[fieldName];
                    if (!(fieldValue.contentid > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, api.getContentItem({ contentID: fieldValue.contentid, languageCode: languageCode, depth: depth - 1 })];
                case 2:
                    childItem = _g.sent();
                    if (childItem != null)
                        fields[fieldName] = childItem;
                    return [3 /*break*/, 8];
                case 3:
                    if (!(fieldValue.sortids && fieldValue.sortids.split)) return [3 /*break*/, 8];
                    sortIDAry = fieldValue.sortids.split(',');
                    childItems = [];
                    _f = 0, sortIDAry_1 = sortIDAry;
                    _g.label = 4;
                case 4:
                    if (!(_f < sortIDAry_1.length)) return [3 /*break*/, 7];
                    childItemID = sortIDAry_1[_f];
                    return [4 /*yield*/, api.getContentItem({ contentID: childItemID, languageCode: languageCode, depth: depth - 1 })];
                case 5:
                    childItem = _g.sent();
                    if (childItem != null)
                        childItems.push(childItem);
                    _g.label = 6;
                case 6:
                    _f++;
                    return [3 /*break*/, 4];
                case 7:
                    fields[fieldName] = childItems;
                    _g.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 1];
                case 9: return [2 /*return*/, contentItem];
            }
        });
    });
};
var expandLinkedList = function (_a) {
    var agility = _a.agility, contentItem = _a.contentItem, languageCode = _a.languageCode, fieldName = _a.fieldName, sortIDField = _a.sortIDField;
    return __awaiter(_this, void 0, void 0, function () {
        var fieldObj, referenceName, listItems, sortIDs, sortIDAry, sortedItems, _loop_1, _i, sortIDAry_2, idStr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!contentItem)
                        return [2 /*return*/, null];
                    fieldObj = contentItem.fields[fieldName];
                    if (!fieldObj)
                        throw Error("The field ".concat(fieldName, " was not found on the content item."));
                    referenceName = fieldObj.referencename;
                    if (!referenceName)
                        throw Error("A referencename property was not found on the ".concat(fieldName, " value."));
                    return [4 /*yield*/, agility.getContentList({ referenceName: referenceName, languageCode: languageCode })];
                case 1:
                    listItems = _b.sent();
                    if ((listItems === null || listItems === void 0 ? void 0 : listItems.length) > 0) {
                        sortIDs = contentItem.fields[sortIDField];
                        if ((sortIDs === null || sortIDs === void 0 ? void 0 : sortIDs.length) > 0 && (sortIDs === null || sortIDs === void 0 ? void 0 : sortIDs.split)) {
                            sortIDAry = sortIDs.split(',');
                            sortedItems = [];
                            _loop_1 = function (idStr) {
                                var childContentID = parseInt(idStr);
                                var childItemIndex = listItems.findIndex(function (item) { return item.contentID === childContentID; });
                                if (childItemIndex >= 0) {
                                    sortedItems.push(listItems[childItemIndex]);
                                    listItems.splice(childItemIndex, 1);
                                }
                            };
                            for (_i = 0, sortIDAry_2 = sortIDAry; _i < sortIDAry_2.length; _i++) {
                                idStr = sortIDAry_2[_i];
                                _loop_1(idStr);
                            }
                            listItems = sortedItems.concat(listItems);
                        }
                    }
                    contentItem.fields[fieldName] = listItems;
                    return [2 /*return*/, contentItem];
            }
        });
    });
};
module.exports = {
    renderHTML: renderHTML,
    cleanHTML: cleanHTML,
    asyncForEach: asyncForEach,
    expandContentItem: expandContentItem,
    expandContentList: expandContentList,
    expandLinkedList: expandLinkedList
};
